import React, { Component } from 'react';
import { connect } from 'react-redux';
import store from '../../store';

import {fetchGet,getRouteInfo} from '../../common/common';
import { getSeatChartResults, getSearchResults, saveEditDetails, toggleFinalSave } from '../../actions/editPolicy-actions';

import PickUp from '../pickUp/PickUp';
import DropOff from '../dropOff/DropOff';
import PassDetails from '../passDetails/PassDetails';
import ComDetails from '../comDetails/ComDetails';
//import {getRouteInfo} from '../../common/common';

class Seatchart extends Component {
    constructor(props){
        super(props);
        this.state = {
            stchrt: [],
            countLower: 0,
            countUpper: 0,
            showActive: 0,
            totalSeat:0,
            selSeatNo: [],
            selectedSeatType:'',
            selectedSeatFare:'',
            pickUp:false,
            dropOff:false,
            passDetails:false, 
            comDetails:false,
            editOptions:[]
        };
    }

    componentDidMount() {
        this.setState({editOptions:this.props.editPolicy.editOptions})

        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        let PaxDetail = APIGetBookingDetailsResult.PaxDetail;
        this.setState({PaxDetail:PaxDetail});

        let fromCityID = APIGetBookingDetailsResult.FromCityID;
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityID = APIGetBookingDetailsResult.ToCityID;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        let rsid = APIGetBookingDetailsResult.RouteCode;
        let journeyDate = APIGetBookingDetailsResult.JourneyDate;
        let mode = 'oneway';
        const that = this;

        let searchurl = '/api/resource/searchRoutes?fromCityID=' + fromCityID + '&toCityID=' + toCityID + '&fromCityName=' + fromCityName + '&toCityName=' + toCityName +'&journeyDate=' + journeyDate + '&mode='+ mode;

            //for app webview pass app agentId in api
            const appAgentId = localStorage.getItem("AgentId");
            if(appAgentId){
                searchurl+='&appAgentId='+appAgentId;
            }

            fetchGet(searchurl).then(function(data) {
                store.dispatch(getSearchResults(data.filter(function(a){ return rsid === a.RouteScheduleId })[0]));
            }).catch(function(error) {
                store.dispatch(getSearchResults(false));
                console.log(error);
            });

        let seatcharturl = '/api/resource/seatArrangement?routeID=' + rsid + '&journeyDate=' + journeyDate;

        //for app webview pass app agentId in api
        if(appAgentId){
            seatcharturl+='&appAgentId='+appAgentId;
        }
        
        fetchGet(seatcharturl).then(function(data) {
            if (data.APIGetChartMicrositeResult.Status) {
                const busDetails = that.props.editPolicy.buses;
                const stchrt = [];
                let selSeatNo = that.state.selSeatNo;
                //let selectedSeatType = that.state.selectedSeatType;
                data.APIGetChartMicrositeResult.Seats.forEach(el => {
                    let baseFare = el.Fare;
                    baseFare -= (el.HasSTax ? parseInt(el.ServiceTax, 10) : 0);
                    baseFare -= (el.HasSCharge ? parseInt(el.ServiceCharge, 10) : 0);

                const opDisFare = busDetails.HasDiscountPolicy ? (busDetails.DiscountAmt > 0 ? busDetails.DiscountAmt : Math.round(baseFare * busDetails.DiscountPer/100)) : 0;
                    busDetails.HasSeater ? that.setState({ HasSeater:1 }) : that.setState({ HasSeater:0 });

                    busDetails.HasSleeper ? that.setState({ HasSleeper:1 }) : that.setState({ HasSleeper:0 });
                    baseFare -= (baseFare > 0 ? parseInt(opDisFare, 10) : 0);
                    el.baseFare = baseFare;

                    let bookingDetails = that.props.editPolicy.data.APIGetBookingDetailsResult[0];
                    let PaxDetail = bookingDetails.PaxDetail;
                    el.selectedSeat = false;
                    PaxDetail.forEach(element => { 
                        if(element.SeatNo === el.SeatLabel){
                            el.selectedSeat = true;
                            selSeatNo.push(el.SeatLabel);
                            //selectedSeatType.indexOf(el.SeatTypeID) === -1 && selectedSeatType.push(el.SeatTypeID);
                        }
                    });

                    that.setState({totalSeat:(parseInt(bookingDetails.TotalSeaterCount)+parseInt(bookingDetails.TotalSleeperCount))});

                    /*let seatTypeArr = [];    
                    bookingDetails.TotalSeaterCount > 0 ?  seatTypeArr.push(1) : seatTypeArr.push(0);
                    bookingDetails.TotalSleeperCount > 0 ? seatTypeArr.push(2) : seatTypeArr.push(0);
                    that.setState({seatType:seatTypeArr});*/

                    /*that.state.seatType.indexOf(el.SeatTypeID) == -1 ? el.allowEditSeat = false : el.allowEditSeat = true;*/
                    stchrt.push(el);
                })

                that.setState({ selSeatNo, stchrt });
                //that.setState({ selSeatNo, stchrt, selectedSeatType });
                that.parseSeats();
            } else {
                that.setState({ error: data.APIGetChartMicrositeResult.ErrorMessage })
            }
            store.dispatch(getSeatChartResults(data));
        }).catch(function(error) {
            console.log(error);
        });

        //let rsid = this.props.editPolicy.data.APIGetBookingDetailsResult[0].RouteCode;
        getRouteInfo(rsid);
    }

    parseSeats = () => {
        let lower = {};
        let upper = {};
        let fares = [];
        let countLower = this.state.countLower;
        let countUpper = this.state.countUpper;
        const st = this.state.stchrt;
    
        st.forEach(el => {
            if (el.baseFare !== 0 && fares.indexOf(el.baseFare) === -1) fares.push(el.baseFare);
            if (el.Deck === 1) {
                if (el.IsAvailable && !el.IsAisle) {
                    countLower++;
                }
                
                if (Object.keys(lower).indexOf(el.ColumnNo + '') === -1) {
                    lower[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        lower[el.ColumnNo].push(el);
                    }
                }
            } else {
                if (el.IsAvailable && !el.IsAisle) {
                    countUpper++;
                }
                if (Object.keys(upper).indexOf(el.ColumnNo + '') === -1) {
                    upper[el.ColumnNo] = [];
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                } else {
                    if (!el.IsAisle) {
                        upper[el.ColumnNo].push(el);
                    }
                }
            }
        });
        lower = this.parseSt(lower);
        upper = this.parseSt(upper);

        const stchrt = { lower, upper }
        this.setState({ stchrt, fares, countLower, countUpper });
    }

    parseSt = (val) => {
        let keys = Object.keys(val);
        for (let i = 0; i < keys.length; i++) {

            if (keys[i + 1] - keys[i] > 1) {
                val[parseInt(keys[i], 10) + 1] = false;
            }
            if (val[keys[i]] && val[keys[i]].length === 0 && val[keys[i + 1]] && val[keys[i + 1]].length === 0) {
                val[keys[i]] = false;
                delete val[keys[i + 1]];
            }
        }
        return val;
    }

    showLegend = () => {
        return (
            <div className = 'legend'>
                <div>
                    <span style = {{ background: '#1fb34b' }}></span>
                    General
                </div>
                <div>
                    <span style = {{ background: '#ddd' }}></span>
                    Selected
                </div>
                <div>
                    <span style = {{ background: '#0295d2' }}></span>
                    Male
                </div>
                <div>
                    <span style = {{ background: '#ec1287' }}></span>
                    Female
                </div>
                <div>
                    <span className = 'st-legend'></span>
                    Seater
                </div>
                <div>
                    <span className = 'st-legend sl'></span>
                    Sleeper
                </div>
            </div>
        )
    }

    availableSeat = (ell) => {
        const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
        return (
            <div>
                { '₹'+ell.baseFare}
                <span style = {{
                    position: 'absolute',
                    left: ell.Height === 1 ? '6px' : '0',
                    bottom: ell.Height === 1 ? '0' : 'initial',
                    height: ell.Height === 1 ? '3px' : 'initial',
                    width: ell.Height === 1 ? '28px' : 'initial', 
                    background: color  
                }}></span>
            </div>
        )
    }

    showLowerSt = () => {
        const loop = this.state.stchrt.lower;
        return (
            <div>
                <div>
                    <div className='lowerTab'>
                        Lower ({ this.state.countLower } Seats)
                    </div>
                    <div className='upperTab' onClick = { () => this.setState({ showActive: 1 }) } style={{border:'2px solid #eee'}}>
                        Upper ({ this.state.countUpper } Seats)
                    </div>
                </div>
                <div className='chart-container'>
                    <span className='border'></span>
                    { Object.keys(loop).map( (el, index) => {
                        if (loop[el] && loop[el].length > 0) {
                            return (
                                <div
                                    key = {index}
                                    style = {{
                                        position:'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: this.getWidthForDiv(loop[el]),
                                        height: this.getHeightForDiv(loop[el])
                                    }}>
                                        { 
                                            Object.keys(loop).length === index + 1 && 
                                            <img src='/img/operator.svg' alt='driver' className='driver'/>
                                        }
                                        { 
                                            loop[el].map( (ell, indexx) => {
                                                return (
                                                    <div
                                                        key = {indexx}
                                                        style = { this.generateSeatStyle(ell) }
                                                        onClick = { () => this.selSeat(ell) }
                                                        >
                                                        { ell.IsAvailable ? this.availableSeat(ell) : (ell.selectedSeat ? '₹'+ell.baseFare : 'Sold')}
                                                    </div>
                                                )
                                            }) 
                                        }
                                </div>
                            )
                        } else {
                            return <div key = {index} style = {{width: '40px'}}></div>
                        }
                    }) }
                </div>
            </div>
        )
    }

    showUpperSt = () => {
        const loop = this.state.stchrt.upper;
        return (
            <div>
                <div className='lowerTab' onClick = { () => this.setState({ showActive: 0 }) } style={{border:'2px solid #eee'}}>
                    Lower ({ this.state.countLower } Seats)
                </div>
                <div className='upperTab'>
                    Upper ({ this.state.countUpper } Seats)
                </div>
                <div className='chart-container'>
                    <span className='border'></span>
                    { Object.keys(loop).map( (el, index) => {
                        if (loop[el] && loop[el].length > 0) {
                            return (
                                <div
                                    key = {index}
                                    style = {{
                                        position:'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: this.getWidthForDiv(loop[el]),
                                        height: this.getHeightForDiv(loop[el])
                                    }}
                                >
                                    { 
                                        Object.keys(loop).length === index + 1 && 
                                        <img src = '/img/operator.svg' alt = 'driver' style={{ position:'absolute',top:'-55px',width:'36px',right:'4px'}}/>
                                    }
                                    { 
                                        loop[el].map( (ell, indexx) => {
                                            return (
                                                <div
                                                    key = {indexx}
                                                    style = { this.generateSeatStyle(ell) }
                                                    onClick = { () => this.selSeat(ell) }
                                                    >
                                                    { ell.IsAvailable ? this.availableSeat(ell) : (ell.selectedSeat ? '₹'+ell.baseFare : 'Sold')}
                                                </div>
                                            )
                                        }) 
                                    } 
                                </div>
                            )
                        } else {
                            return <div key = {index} style = {{width: '40px'}}></div>
                        }
                    }) }
                </div>
            </div>
        )
    }

    getWidthForDiv = (el) => {
        for (let i = 0; i < el.length; i++) {
            if (el[i].Width === 1) {
               return '60px';
            } else {
                return '100px';
            }            
        }
        return '60px';
    }

    getHeightForDiv = (el) => {
        let tempHt = 0;
        for (let i = 0; i < el.length; i++) {
            tempHt += (el[i].Height * 45);    
        }
        return (tempHt + 'px');
    }

    generateSeatStyle = (ell) => {
        const color = ell.Gender === 'M' ? '#0295d2' : (ell.Gender === 'F' ? '#ec1287' : '#1eb24b');
        const opacity = this.state.selectedSeatType === '' ? '1' : (this.state.selectedSeatFare === ell.baseFare && this.state.selectedSeatType === ell.SeatTypeID ? '1':'0.2');
        //const opacity = this.state.selectedSeatType === '' ? '1' : (this.state.selectedSeatType === ell.SeatTypeID ? '1' : '0.2');
        return {
            position: 'absolute',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: (ell.Height * 40) + 'px',
            width: (ell.Width * 40) + 'px',
            margin: '5px',
            padding: (ell.IsAvailable || ell.selectedSeat || ell.Height !== 2 ? '5px' : '0'),
            border: '1px solid',
            borderColor: (ell.IsAvailable || ell.selectedSeat) ? color : '#ddd',
            background: (ell.IsAvailable || ell.selectedSeat) ? (this.state.selSeatNo.indexOf(ell.SeatLabel) >= 0 ? color : '#fff') : '#ddd',
            color: this.state.selSeatNo.indexOf(ell.SeatLabel) >= 0 ? '#fff' : '#444',
            userSelect: 'none',
            top:(ell.RowNo*45) + 'px',
            boxSizing:'border-box',
            opacity:opacity,
            fontSize: '.85rem'
        }
    }

    selSeat = (val) => {
        if((this.state.selectedSeatType === '' || this.state.selectedSeatType === val.SeatTypeID) && (this.state.selectedSeatFare === '' || this.state.selectedSeatFare === val.baseFare)){
            let selectedSeatType = '';
            let selectedSeatFare = '';
            
            let tmpstate = this.state.PaxDetail;
            tmpstate.forEach(el => {
                if(el.SeatNo === val.SeatLabel){
                    el.SeatNo = '';
                }else{
                    if(el.SeatNo === ''){
                        el.SeatNo = val.SeatLabel;
                        el.Fare = val.baseFare;
                        el.Tax = val.ServiceTax;
                    }
                }
            })
            
            this.setState({PaxDetail:tmpstate});

            //const bus = this.props.editPolicy.buses;
            let selSeatNo = this.state.selSeatNo;
            //let selectedSeatType = this.state.selectedSeatType;

            if ((val.IsAvailable || val.selectedSeat)  ) {
                const index = selSeatNo.indexOf(val.SeatLabel);
                
                if (index === -1 && selSeatNo.length < this.state.totalSeat) {
                    selSeatNo.push(val.SeatLabel);
                    //if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                        //let temp = 0;
                        //temp += val.baseFare;
                        //temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.round((temp * bus.DiscountPer / 100));
                        //disSeatFare += temp;
                    //}
                }

                if (index >= 0) {
                    selectedSeatType = val.SeatTypeID;
                    selectedSeatFare = val.baseFare;
                    selSeatNo.splice(index, 1);
                    //if (bus.DiscountAmt > 0 || bus.DiscountPer) {
                        //let temp = 0;
                        //temp += val.baseFare;
                        //temp -= bus.DiscountAmt > 0 ? bus.DiscountAmt : Math.round((temp * bus.DiscountPer / 100));
                        //disSeatFare -= temp;
                    //}
                }
                this.setState({ selSeatNo,selectedSeatType,selectedSeatFare});
            }
        }
    }

    checkEditOption = () => {
        let editDetails = [];
        editDetails['seatNo'] = this.state.selSeatNo;
        editDetails['PaxDetail'] = this.state.PaxDetail;
        store.dispatch(saveEditDetails(editDetails));

        const editOptions = this.props.editPolicy.editOptions;
        let flag = 0;
        for (var i = 0; i < editOptions.length; i++) {
            let el = editOptions[i];
            if(el.value === 'on' && el.name !== 'seatChart') {
                this.setState({ [el.name]:true});
                flag =1;
                break;
            }
        }
        if(flag === 0) {
            store.dispatch(toggleFinalSave(true)); 
        }
    }

    getDate = (val) => {
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
        let journeyDate = new Date(val);
        let date = journeyDate.getDate();
        let month = months[journeyDate.getMonth()];
        let day = weekday[journeyDate.getDay()];
        let jDate = day+', '+date+' '+month;
        return jDate;
    }

    closeSlider = (name,value) => {
        this.setState({[name]:value});
    }
    
    seatChart = () => {
        let APIGetBookingDetailsResult = this.props.editPolicy.data.APIGetBookingDetailsResult[0];
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        let journeyDate = this.getDate(APIGetBookingDetailsResult.JourneyDate);

        return(
            <div>
                <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                    <span className='back-arrow' onClick = { () => { this.props.closeSlider('seatChart',false); store.dispatch(toggleFinalSave(false)) }} >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                            <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"/>
                        </svg>
                    </span>
                    <span className='header-title'>
                        {fromCityName} - {toCityName} {journeyDate}
                    </span>
                </div>
                <div className='ep-wrapper' style={{zIndex:'5'}}>
                    { this.showLegend() }
                    <div className = 'chart-wrap'>
                        { this.state.showActive === 0 ? this.showLowerSt() : (this.state.stchrt.upper ? this.showUpperSt() : '') }
                    </div>
                    <div style={{position:'fixed',left:'0',bottom:'0',background: '#fff',padding: '20px',fontSize:'.85rem',boxShadow:'0 -1px 2px 1px #ddd'}}>
                        <div style={{color:window.color['searchBoxBgColor']}}>How To Edit ?</div>
                        <div style={{color:'#666'}}>Choose the seat which you want to edit and then select a seat from the available ones</div>
                        <div style={{display:'flex'}}>
                            <div className='btn1' style={{background: '#fff',color:'#444',border:'1px solid #d7d7d7',marginRight:'10px'}} onClick={()=>this.routechange()}>Cancel</div>
                            <div className='btn1' style={{background: window.color['buttonColor'],color:'#fff'}} onClick={()=>this.checkEditOption()}>PROCEED</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    routechange = () => {
        window.location.href = "/edit_policy";
    } 

    render() {
        if (this.state.stchrt.lower) {
            return (
                <div>
                    {this.seatChart()}
                    {this.state.pickUp && <PickUp closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
                    {this.state.dropOff && <DropOff closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
                    {this.state.passDetails && <PassDetails closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
                    {this.state.comDetails && <ComDetails closeSlider = {(a,b) => this.closeSlider(a,b)} /> }
                </div>
            )
        } else {
            return (
                <div>
                    <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                        <span className='back-arrow' >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='25px' fill='#fff'>
                                <path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z"/>
                            </svg>
                        </span>
                        <span className='header-title'>
                            Edit Booking
                        </span>
                    </div>
                    <div>
                        Loading...
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            )
        }
    }
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Seatchart);


// WEBPACK FOOTER //
// ./src/components/seatchart/Seatchart.js